module.exports = "/static/Images/es/Two.png";